module.exports = __webpack_public_path__ + "static/document-2a00246915a600a38453a790d2efc54f.png";